<template>
  <div id="app">
    <router-view  v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>

<script>
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
   name: 'app',
   methods:{
	   ...mapMutations(['sSetUserInfo','sSetToken']),
	   clearCache(){
		   this.sSetUserInfo('');
		   this.sSetToken('');
		   window.localStorage.removeItem('starbucks');
		   window.sessionStorage.removeItem('starbucks');
	   }
   },
   unload(){
    // alert('unload')
      // console.log('unload');
	  //  this.clearCache();
   },
   components: {
    }
}
</script>

<style>


div{
	box-sizing: border-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;

}

body,html {
	width: 100%;
	height: 100%;
	background-color: #ffffff;
}

</style>
